import { createSelector } from 'reselect';

const selectUser = (state) => {
  return state.user;
};

export const selectUserAddress = createSelector(
  [selectUser],
  (user) => {
    return user.fullAddress;
  }
);

export const selectUserPlaceId = createSelector(
  [selectUser],
  (user) => {
    return user.placeID;
  }
);

export const selectUserValidAddress = createSelector(
  [selectUser],
  (user) => {
    return user.validAddress;
  }
);

export const selectUserLat = createSelector(
  [selectUser],
  (user) => {
    return user.latitude;
  }
);

export const selectUserLng = createSelector(
  [selectUser],
  (user) => {
    return user.longitude;
  }
);

export const selectUserAlert = createSelector(
  [selectUser],
  (user) => {
    return user.alertMessage;
  }
);

export const selectOverlayIsVisible = createSelector(
  [selectUser],
  (user) => {
    return user.overlayIsVisible;
  }
);

export const selectUniqueMapId = createSelector(
  [selectUser],
  (user) => {
    return user.uniqueMapId;
  }
);

export const selectWindToggleIsActive = createSelector(
  [selectUser],
  (user) => {
    return user.windToggleIsActive;
  }
);

export const selectPollutantPopupType = createSelector(
  [selectUser],
  (user) => {
    return user.pollutantPopupTypeId;
  }
);